import React from 'react';
import {createRoot} from 'react-dom/client';
import BroadbandLabel from "./BroadbandLabel"

const planCards = document.querySelectorAll(".broadBandLabelPlanCard")

if(planCards && planCards.length > 0) {
    planCards.forEach((card) => {
        const labelData = card.getAttribute('data-broadbandData');
        const root = createRoot(card);
        root.render(<BroadbandLabel labelData={labelData} />);
    })
}